/* eslint-disable max-len */
import { MasterQuestionConfig } from "../questionnaires/questionnaireConfig/models";

import * as questionIds from "./questionnaireBQuestionsIds";

export const questionnaireBMasterConfig: MasterQuestionConfig[] = [
    {
        id: questionIds.IsTheIndividualMentionedAboveCurrentlyAtWorkAndNoLongerAbsentDueToSickness,
        questionText: "Is the individual mentioned above currently at work and no longer absent due to sickness?",
        canBeDisabled: false
    },
    {
        id: questionIds.WhenDidTheyReturnToWork,
        questionText: "When did they return to work?",
        canBeDisabled: false
    },
    {
        id: questionIds.WhichOfTheFollowingBestDescribesTheCurrentWorkSituation,
        questionText: "Which of the following best describes the current work situation?",
        canBeDisabled: false
    },
    {
        id: questionIds.AtWorkDidTheReportAndRecommendationsHaveHelpedToFacilitateSustainableReturnToWork,
        questionText: "In your opinion do you think the report from OH (and where applicable any recommendations for adjustments) has helped to facilitate a sustainable return to work?",
        canBeDisabled: false
    },
    {
        id: questionIds.WhichOfTheFollowingBestDescribesTheSituationWithRegardsToReturnToWorkInTheFuture,
        questionText: "Which of the following best describes the situation with regards to a return to work in the future?",
        canBeDisabled: false
    },
    {
        id: questionIds.WhichOfTheFollowingBestDescribesWhyTheEmployeeHasNotReturnedToWork,
        questionText: "Which of the following best describes why the employee has not returned to work?",
        canBeDisabled: false
    },
    {
        id: questionIds.NotAtWorkDidTheReportAndRecommendationsHelpWithManagementOfTheIndividualsAbsenceFromWork,
        questionText: "In your opinion did the report and recommendations from Occupational Health help you with management of the individual’s absence from work?",
        canBeDisabled: false
    },
    {
        id: questionIds.DontKnowDidTheReportAndRecommendationsHelpWithManagementOfTheIndividualsAbsenceFromWork,
        questionText: "In your opinion did the report and recommendations from Occupational Health help you with management of the individual’s absence from work?",
        canBeDisabled: false
    }
];
